import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

const OFFICE_BEARERS = ["President", "Vice President", "Secretary", "Joint Secretary", "Treasurer", "Executive Committee Members"];

const SPECIALIZED = [
    { title: "Membership Committee", desc: "Membership approval and verification." },
    { title: "Exhibition Committee", desc: "Exhibition planning and stall allocation." },
    { title: "Finance Committee", desc: "Financial management and budgeting." },
    { title: "Dispute Resolution Committee", desc: "Member dispute handling and resolution." },
    { title: "Technical Committee", desc: "Technical guidance and industry development." },
];

export default function Committee() {
    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />

            <section className="bg-[#0F172A] text-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Governance</div>
                    <h1 className="font-display text-4xl lg:text-6xl font-bold tracking-tight max-w-4xl">Executive Committee.</h1>
                    <p className="mt-6 text-white/70 max-w-2xl leading-relaxed">Responsible for policy formulation, governance, membership approval, and strategic development of the Association.</p>
                </div>
            </section>

            {/* Office Bearers */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Office Bearers</div>
                <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#0F172A] leading-tight mb-14">Federation leadership.</h2>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
                    {OFFICE_BEARERS.map((o, i) => (
                        <div key={o} className="bg-white p-8" data-testid={`bearer-${i}`}>
                            <div className="font-mono text-xs text-[#D4AF37] mb-3">{String(i + 1).padStart(2, "0")}</div>
                            <div className="font-display text-xl font-bold text-[#0F172A]">{o}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Specialized Committees */}
            <section className="bg-[#F8F9FA] border-y border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Specialized Committees</div>
                    <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#0F172A] leading-tight mb-14">Five focused working groups.</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
                        {SPECIALIZED.map((c, i) => (
                            <div key={c.title} className="bg-white p-8" data-testid={`spec-${i}`}>
                                <div className="font-mono text-xs text-[#D4AF37] mb-4">{String(i + 1).padStart(2, "0")}</div>
                                <h3 className="font-display text-xl font-bold text-[#0F172A] mb-2">{c.title}</h3>
                                <p className="text-sm text-[#64748B] leading-relaxed">{c.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <PublicFooter />
        </div>
    );
}
